import tailwindConfig from '../tailwind.config';

//https://nuxt.com/docs/guide/directory-structure/app-config
export default defineAppConfig({
    extends: ['@nuxt-monorepo/base'],
    tailwindCss: {
        config: tailwindConfig,
    },
});
